import { CardBody } from 'reactstrap'
import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const Rule = styled.div`
  background: #e6e6e6;
  width: 1px;
  height: 100%;
  margin: 0 40px;

  @media (max-width: 1360px) {
    height: 1px;
    width: 100%;
    margin: 40px 0;
  }
`

export const Container = styled(CardBody)`
  padding: 0 !important;
  display: grid;
  grid-template: 1fr / 1fr auto 1fr;

  @media ${queries.less.mdl} {
    grid-template: auto auto / 1fr;
  }
`
